module.exports = __webpack_public_path__ + "static/media/wood.0fffd697.jpg";